// Import React Library
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowForward } from "react-icons/io5";

// Cover component
const Cover = ({ section, coverTitle, coverSubtitle }) => {
    const navigate = useNavigate();

    return (
        <section
            className={
                section + '-cover-section cover-section min-h-screen flex flex-col justify-center items-center text-center px-4'
            }
        >
            {coverTitle ? <h1>{coverTitle}</h1> : <h1>PreHouse Uruguay</h1>}

            {coverSubtitle ? (
                <h2>{coverSubtitle}</h2>
            ) : (
                <h2>
                    Isopaneles | Construcciones | Hierros | Aberturas | Pisos | Herramientas
                </h2>
            )}
        </section>
    );
};

export default Cover;
